export var generateCategories = function () { return [
    { id: 0, name: 'animals' },
    { id: 1, name: 'beard' },
    { id: 2, name: 'business' },
    { id: 3, name: 'cars' },
    { id: 4, name: 'city' },
    { id: 5, name: 'flowers' },
    { id: 6, name: 'food' },
    { id: 7, name: 'nature' },
    { id: 8, name: 'people' },
    { id: 9, name: 'sports' },
    { id: 10, name: 'tech' },
    { id: 11, name: 'travel' },
    { id: 12, name: 'water' },
]; };
//# sourceMappingURL=categories.js.map